<script>
export let namelogo;
export let descriptionus;
export let menuTextAutomation;
export let menuTextContact;
export let TextContact;
export let phone;
export let address;

</script>

<footer class="footer pos-r grey-bg bg-contain bg-pos-lt">
    <div class="primary-footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="footer-logo">
                        <img alt="" class="img-center" id="footer-logo-img" src="https://storage.googleapis.com/cms.lobesoft.com/2019/12/2e0fe48e-pittogrammacolorato.png">
                        <span class="logo">{namelogo}</span>
                    </div>
                    <p class="mb-0">{descriptionus}
                    </p>
                </div>
                <div class="col-lg-4 col-md-6 pl-md-5 sm-mt-5 footer-list justify-content-between d-flex">
                    <ul class="list-unstyled w-100">
                        <li><a href="#bannerhome">Home</a> </li>
                        <li><a href="#website">Web</a></li>
                        <li><a href="#hardware">Hardware</a></li>
                        <li><a href="#automation">{menuTextAutomation}</a></li>
                        <li><a href="#footer">{menuTextContact}</a></li>
                    </ul>

                </div>
                <div class="col-lg-4 col-md-12 md-mt-5">
                    <ul class="media-icon list-unstyled">
                        <li>

                        </li>
                        <li style="font-weight: bold">
                            {TextContact}
                        </li>
                        <li></li>
                        <li>Email: <a href="mailto:info@lobesoft.com"><b>info@lobesoft.com</b></a>
                        </li><li> {phone}
                    </li>
                    <li>
                        {address}
                    </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="secondary-footer">
        <div class="container">
            <div class="copyright">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12"><span>Copyright {new Date().getUTCFullYear()} Lobesoft  | All Rights Reserved</span>
                    </div>
                    <div class="col-lg-6 col-md-12 text-lg-right md-mt-3">

                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>

<style>

    *,::after,::before{box-sizing:border-box;}
    footer{display:block;}
    p{margin-top:0;margin-bottom:1rem;}
    ul{margin-top:0;margin-bottom:1rem;}
    b{font-weight:bolder;}
    a{color:#007bff;text-decoration:none;background-color:transparent;}
    a:hover{color:#0056b3;text-decoration:underline;}
    img{vertical-align:middle;border-style:none;}
    .list-unstyled{padding-left:0;list-style:none;}
    .container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;}
    @media (min-width:576px){
        .container{max-width:540px;}
    }
    @media (min-width:768px){
        .container{max-width:720px;}
    }
    @media (min-width:992px){
        .container{max-width:960px;}
    }
    @media (min-width:1200px){
        .container{max-width:1170px;}
    }
    .row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px;}
    .col-lg-4,.col-lg-6,.col-md-12,.col-md-6{position:relative;width:100%;padding-right:15px;padding-left:15px;}
    @media (min-width:768px){
        .col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;}
        .col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%;}
    }
    @media (min-width:992px){
        .col-lg-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%;}
        .col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;}
    }
    .d-flex{display:-ms-flexbox!important;display:flex!important;}
    .justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important;}
    .align-items-center{-ms-flex-align:center!important;align-items:center!important;}
    .w-100{width:100%!important;}
    .mb-0{margin-bottom:0!important;}
    @media (min-width:768px){
        .pl-md-5{padding-left:3rem!important;}
    }
    @media (min-width:992px){
        .text-lg-right{text-align:right!important;}
    }
    @media print{
        *,::after,::before{text-shadow:none!important;box-shadow:none!important;}
        a:not(.btn){text-decoration:underline;}
        img{page-break-inside:avoid;}
        p{orphans:3;widows:3;}
        .container{min-width:992px!important;}
    }
    /*! CSS Used from: https://lobesoft.com/base.css */
    a:focus{text-decoration:none!important;}
    a:focus,a:hover{color:#2575fc;text-decoration:none!important;}
    a{outline:medium none!important;color:#2575fc;}
    *::-moz-selection{background:#2575fc;color:#fff;text-shadow:none;}
    ::-moz-selection{background:#2575fc;color:#fff;text-shadow:none;}
    ::selection{background:#2575fc;color:#fff;text-shadow:none;}
    a,img,span{-webkit-transition:all 0.5s ease-in-out 0s;-moz-transition:all 0.5s ease-in-out 0s;-ms-transition:all 0.5s ease-in-out 0s;-o-transition:all 0.5s ease-in-out 0s;transition:all 0.5s ease-in-out 0s;}
    .footer{padding:80px 0;}
    .primary-footer{position:relative;z-index:99;font-size:16px;}
    .secondary-footer{color:#5f5f5f;font-weight:normal;}
    .copyright{margin-top:50px;}
    .footer-logo img{height:50px;}
    .primary-footer,.primary-footer a{color:#1c1d3e;}
    .media-icon li{margin-bottom:15px;font-size:16px;font-weight:400;}
    .media-icon li:last-child{margin-bottom:0;}
    .media-icon li a{color:#2575fc;}
    .media-icon li a:hover{text-decoration:underline!important;}
    .footer-list li{margin-bottom:15px;text-transform:capitalize;}
    .footer-list li:last-child{margin-bottom:0;}
    .footer-list li a{position:relative;font-size:16px;font-weight:400;color:#1c1d3e;}
    .footer-logo{margin-bottom:15px;}
    /*! CSS Used from: https://lobesoft.com/style.css */
    ul{margin:0px;padding:0px;}
    .logo{font-family:"azonix";margin-left:1em;}
    p{line-height:1.7;}
    .img-center{display:inline-block!important;max-width:100%;}
    .pos-r{position:relative;}
    .grey-bg{background-color:#f3f5ff;}
    [data-bg-img]{background-size:cover;background-position:center center;background-repeat:no-repeat;}
    .bg-contain{background-size:contain;}
    .bg-pos-lt{background-position:left top;}
    /*! CSS Used from: https://lobesoft.com/responsive.css */
    @media (max-width: 992px){
        .md-mt-3{margin-top:30px!important;}
        .md-mt-5{margin-top:50px!important;}
    }
    @media (max-width: 767px){
        .sm-mt-5{margin-top:50px!important;}
    }
    /*! CSS Used from: https://lobesoft.com/color-2.css */
    a,a:focus,a:hover,.footer-list li a:hover,.media-icon li a{color:#8e60fa;}
    .purple{color:#8e60fa;}
    /*! CSS Used from: Embedded */
    *{box-sizing:border-box;}
    .row{margin:10px -16px;}
    .row{padding:20px;}
    .row:after{content:"";display:table;clear:both;}
    /*! CSS Used fontfaces */
    @font-face{font-family:'azonix';src:url('/fonts/Azonix.otf');}
</style>